import React, { useState } from 'react';
import { Mention, MentionsInput } from 'react-mention';

import styles from './styles.module.less';

const DEBOUNCING_TIME = 275; // in milliseconds

const AutoresizeMentionTextarea = props => {
  const [timeoutId, setTimeoutId] = useState(undefined);

  const {
    value,
    onChange,
    placeholder,
    fetch,
    textRef,
    onFocus,
    onKeyDown,
    debouncingTime,
  } = props;

  const getUsersList = (query, callback) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    setTimeoutId(
      setTimeout(async () => {
        setTimeoutId(undefined);
        callback(await fetch(query));
      }, debouncingTime || DEBOUNCING_TIME)
    );
  };

  // Renders the mention in the text input
  const displayTransform = (_id, display) => {
    return display;
  };

  // Renders the suggestion list per <li/>
  const renderSuggestion = user => {
    return <span>{user.display}</span>;
  };

  return (
    <MentionsInput
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      classNames={styles}
      allowSpaceInQuery={true}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      inputRef={textRef}
    >
      <Mention
        trigger="@"
        data={getUsersList}
        markup={'@[__display__](__id__)'}
        renderSuggestion={renderSuggestion}
        displayTransform={displayTransform}
      />
    </MentionsInput>
  );
};

export default AutoresizeMentionTextarea;
